import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { IsComponentPermission } from "../utils/utils";

const usePermissions = () => {
  const { pathname } = useLocation();
  const [isPermissions, setIsPermissions] = useState({
    view: false,
    edit: false,
    delete: false,
    add: false,
  });
  const { staffPermission }: any = useAppSelector((state) => state.staff);
  useEffect(() => {
    if (staffPermission?.data) {
      const isViewPer = IsComponentPermission(pathname, "view", staffPermission.data);
      const isAddPer = IsComponentPermission(pathname, "add", staffPermission.data);
      const isEditPer = IsComponentPermission(pathname, "edit", staffPermission.data);
      const isDeletePer = IsComponentPermission(pathname, "delete", staffPermission.data);

      setIsPermissions({
        view: isViewPer,
        add: isAddPer,
        edit: isEditPer,
        delete: isDeletePer,
      });
    }
  }, [pathname, staffPermission]);

  return isPermissions;
};

export default usePermissions;
